import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle, Instagram, Facebook, Linkedin } from "lucide-react";
import { BRAND } from "@/lib/content";

const waLink = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent("Hi Komel, I'd like to know more about a Scientific Vastu consultation.")}`;

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-white/10 section-bg" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 md:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center">
            <img src={BRAND.logo} alt="ENRICH VASTU" className="h-[88px] w-[132px] object-contain" />
          </div>
          <p className="mt-5 text-white leading-relaxed max-w-sm">
            A premium Scientific Vastu consultancy blending ancient wisdom with modern energy science — trusted across Dubai and the UAE.
          </p>
          <div className="flex gap-3 mt-6">
            {[
              [Instagram, "https://www.instagram.com/vastuindubai/?hl=en"],
              [Facebook, "https://www.facebook.com/komelvalieaastrologervastudubai/"],
              [Linkedin, "https://www.linkedin.com/in/komel-valliea-0578a82a/?isSelfProfile=false"],
            ].map(([Icon, href], i) => (
              <a key={href} href={href} target="_blank" rel="noreferrer" className="grid place-items-center h-10 w-10 rounded-full border border-white/10 text-white transition-colors hover:text-gold hover:border-gold/40" data-testid={`footer-social-${i}`}>
                <Icon size={17} />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="overline text-gold mb-5">Explore</h4>
          <ul className="space-y-3 text-white">
            {[["Home", "/"], ["About Komel", "/about"], ["Services", "/services"], ["Projects", "/projects"], ["Gallery", "/gallery"]].map(([l, p]) => (
              <li key={p}><Link className="hover:text-white transition-colors" to={p}>{l}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="overline text-gold mb-5">Tools</h4>
          <ul className="space-y-3 text-white">
            {[["Daily Horoscope", "/horoscope"], ["Numerology", "/numerology"], ["Blog", "/blog"], ["FAQ", "/faq"], ["Contact", "/contact"]].map(([l, p]) => (
              <li key={p}><Link className="hover:text-white transition-colors" to={p}>{l}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4 md:pl-5">
          <h4 className="overline text-gold mb-5">Get in Touch</h4>
          <ul className="space-y-4 text-white">
            <li className="flex items-center gap-3"><Phone size={17} className="text-primary-green" /> <a className="hover:text-white" href={`tel:${BRAND.phoneRaw}`}>{BRAND.phone}</a></li>
            <li className="flex items-center gap-3"><Mail size={17} className="text-primary-green" /> <a className="hover:text-white" href={`mailto:${BRAND.email}`}>{BRAND.email}</a></li>
            <li className="flex items-center gap-3"><MessageCircle size={17} className="text-primary-green" /> <a className="hover:text-white" href={waLink} target="_blank" rel="noreferrer">WhatsApp Komel</a></li>
            <li className="flex items-center gap-3"><MapPin size={17} className="text-primary-green" /> {BRAND.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white">
          <p>© {new Date().getFullYear()} ENRICH VASTU · Komel Valliea. All rights reserved.</p>
          <p>Scientific Vastu · Astrology · Numerology · Energy Scanning</p>
        </div>
      </div>
    </footer>
  );
}
